import { Platform, StyleSheet, TextStyle } from 'react-native';

import { primitive } from 'styles/constants';

/**
 * Keep the extra weight on iOS only. Combining `fontWeight` with BK custom fonts
 * causes Android to fall back to a system font instead of rendering Flame.
 */
export const iosCartBoldWeight = (Platform.select({
  ios: { fontWeight: 'bold' },
  default: {},
}) ?? {}) as TextStyle;

export const commonStyles = StyleSheet.create({
  cartEntryBody: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.$bbqBrown,
  },
  cartEntryItemName: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$headers,
    ...iosCartBoldWeight,
    color: primitive.$bbqBrown,
  },
  withBorderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
});
